import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { BOX_IMAGE, CHECKOUT_URL, CTA_LABEL, GUARANTEE_LINE, PRODUCT_CLAIM, PRODUCT_NAME, offerIncludes } from '../data/atlante';
export function Offer() {
  return <section id="offerta" className="scroll-mt-2 bg-navy px-4 py-5 sm:py-7" data-id="element-104" data-mp="1mpd6y7w7o791">
      <div className="mx-auto max-w-2xl" data-id="element-105" data-mp="1hp7l58cmheyv">
        <p className="text-center font-display text-[10px] font-extrabold uppercase tracking-[0.2em] text-gold sm:text-xs" data-id="element-106" data-mp="tylb5bj25km8">
          Offerta speciale di lancio
        </p>
        <h2 className="mt-1 text-center text-xl leading-tight text-white sm:text-2xl" data-id="element-107" data-mp="p24q4q75nmdd">
          🦷 {PRODUCT_NAME}
        </h2>
        <p className="mt-1 text-center font-display text-[11px] font-extrabold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-108" data-mp="yy7tfzdqtr1w">
          {PRODUCT_CLAIM}
        </p>

        <a href={CHECKOUT_URL} className="mt-2 block" data-id="element-109" data-mp="2feakjxph9fvg">
          <img src={BOX_IMAGE} alt="ATLANTE VISIVO DI PROTESI DENTALE™ — sistema completo 6-in-1" className="mx-auto w-full max-w-[200px] drop-shadow-2xl transition-transform duration-200 ease-soft hover:scale-[1.02]" data-id="element-110" data-mp="2ac1tx802upwi" />
        </a>

        <div className="mt-3 rounded-xl border-4 border-gold bg-white p-4 text-center shadow-2xl" data-id="element-111" data-mp="zhvdejeku6vb">
          <p className="font-display text-[13px] font-extrabold uppercase tracking-wide text-navy" data-id="element-112" data-mp="13ki76put61v5">
            Sistema visuale completo 6-in-1
          </p>

          <ul className="mt-2 grid gap-1 text-left sm:grid-cols-2" data-id="element-113" data-mp="6rms4ioqv6ci">
            {offerIncludes.map(item => <li key={item} className="flex items-start gap-1.5 text-[13px] font-semibold leading-snug text-navy" data-id="element-114" data-mp="fufj0ku0lg1t">
                <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-green" aria-hidden="true" data-id="element-115" data-mp="kmp3hlcd1nwp" />
                {item}
              </li>)}
          </ul>

          <div className="mt-3 flex items-baseline justify-center gap-2" data-id="element-116" data-mp="3o84olxs14s93">
            <span className="text-base font-bold text-slate2 line-through" data-id="element-117" data-mp="ve63ofsftzvx">
              97 €
            </span>
            <span className="font-display text-5xl font-extrabold leading-none text-navy sm:text-6xl" data-id="element-118" data-mp="qge1msy2wxe0">
              27 €
            </span>
          </div>

          <p className="mt-1 font-display text-[11px] font-extrabold uppercase tracking-wide text-green" data-id="element-119" data-mp="1067ahm6u6yek">
            🔥 OTTIENI {PRODUCT_NAME} OGGI
          </p>

          <CTAButton className="mt-2.5" data-id="element-120" data-mp="7hrxt6b6gs6e">{CTA_LABEL}</CTAButton>

          <p className="mt-1.5 text-[11px] font-bold text-slate2" data-id="element-121" data-mp="7jct4y5bgf5b">
            Accesso digitale immediato
          </p>
          <p className="mt-0.5 text-[11px] font-bold text-navy" data-id="element-122" data-mp="lfglelwmqdf5">
            {GUARANTEE_LINE}
          </p>
        </div>
      </div>
    </section>;
}